import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { createOrganization, formatApiError } from '../lib/api';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Loader2, Building2, ArrowRight } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_agent-hub-177/artifacts/isc5pm97_Apollo%20Wide%20Logo.png";

const OnboardingPage = () => {
  const [orgName, setOrgName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { refreshUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await createOrganization(orgName);
      await refreshUser();
      navigate('/dashboard');
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8" data-testid="onboarding-page">
      <div className="bg-card border border-border rounded-xl p-8 w-full max-w-lg shadow-xl">
        <div className="flex items-center justify-center mb-6">
          <img src={LOGO_URL} alt="Apollo" className="h-10 w-auto" />
        </div>
        
        <div className="w-14 h-14 bg-gradient-to-br from-[#9333EA]/20 to-[#EC4899]/20 rounded-xl flex items-center justify-center mb-6 mx-auto">
          <Building2 className="w-7 h-7 text-[#9333EA]" />
        </div>
        
        <h1 className="text-2xl font-semibold tracking-tight mb-2 font-['Outfit'] text-center">Create your organization</h1>
        <p className="text-muted-foreground mb-6 text-center">This is where your agents and team will live</p>

        {error && (
          <div className="bg-red-500/10 border border-red-500/20 text-red-500 px-4 py-3 rounded-lg mb-6 text-sm" data-testid="onboarding-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="orgName">Organization name</Label>
            <Input
              id="orgName"
              type="text"
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
              placeholder="Acme Inc."
              required
              className="rounded-lg"
              data-testid="org-name-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full btn-gradient text-white rounded-lg h-11 gap-2 font-medium"
            data-testid="create-org-button"
          >
            {loading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <>
                Continue
                <ArrowRight className="w-4 h-4" />
              </>
            )}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default OnboardingPage;
